import React from "react";
import VqqOverviewContactsField from "./VqqOverviewContactsField";
import {
  formatPlatformRoleLabel,
  pluralizeContactLabel,
} from "../utils/overviewContactsShared";
import { useVqqOverviewContacts } from "../utils/useVqqOverviewContacts";

/**
 * Overview tab Vendor + Sponsor contact managers (story 14534).
 */
export default function VqqOverviewContactsSection({
  userRole,
  rfisDetails,
  refetch,
  activityRefetch,
}) {
  const {
    permissions: contactPermissions,
    savedVendorContacts,
    savedSponsorContacts,
    vendorPickerContacts,
    sponsorPickerContacts,
    vendorKnownEmails,
    sponsorKnownEmails,
    savingVendor,
    savingSponsor,
    saveContacts,
    resendInvites,
    createUser,
  } = useVqqOverviewContacts({
    userRole,
    rfisDetails,
    refetch,
    activityRefetch,
  });

  const assignedPlatformRole = formatPlatformRoleLabel("RFI Manager");

  return (
    <>
      <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4">
        <h2 className="text-sm font-medium text-gray-900">
          {pluralizeContactLabel("Sponsor Contact", savedSponsorContacts.length)}
        </h2>
        <div className="mt-1 text-sm text-gray-700 sm:col-span-2 sm:mt-0">
          <VqqOverviewContactsField
            mode="sponsor"
            contacts={savedSponsorContacts}
            availableContacts={sponsorPickerContacts}
            knownOrgEmails={sponsorKnownEmails}
            canEdit={contactPermissions.canEditSponsor}
            showPlatformRoles={contactPermissions.showSponsorPlatformRoles}
            assignedPlatformRole={assignedPlatformRole}
            saving={savingSponsor}
            onSave={(draft) => saveContacts("sponsor", draft)}
            onCreateUser={(form) => createUser("sponsor", form)}
          />
        </div>
      </div>

      <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4">
        <h2 className="text-sm font-medium text-gray-900">
          {pluralizeContactLabel("Vendor Contact", savedVendorContacts.length)}
        </h2>
        <div className="mt-1 text-sm text-gray-700 sm:col-span-2 sm:mt-0">
          <VqqOverviewContactsField
            mode="vendor"
            contacts={savedVendorContacts}
            availableContacts={vendorPickerContacts}
            knownOrgEmails={vendorKnownEmails}
            canEdit={contactPermissions.canEditVendor}
            showPlatformRoles={contactPermissions.showVendorPlatformRoles}
            assignedPlatformRole={assignedPlatformRole}
            useAddContactLabels={contactPermissions.useAddContactLabelsOnVendor}
            saving={savingVendor}
            onSave={(draft) => saveContacts("vendor", draft)}
            onResendInvite={(targets, options) => resendInvites("vendor", targets, options)}
            onCreateUser={(form) => createUser("vendor", form)}
          />
        </div>
      </div>
    </>
  );
}
